import React from 'react'
import ReactDOM from 'react-dom/client';
import CartPreOrderWrapV1 from 'ReactApp/Components/CartPreOrderWrapV1/CartPreOrderWrapV1';
import { showableCartInstance } from 'ReactApp/Ddd/Aggregates/ShowableCart'
import { CartHtmlIdentifierEnum } from 'ReactApp/Types/enum';
import InitAfterRenderV1 from "../../Components/InitAfterRenderV1/InitAfterRenderV1";
import {biMarketingEventRunnerRun} from "../../../app/frontend/assets/js/services/bi/WithBiMarketingEventRunner";
import {MarketingEventTypeEnum} from "../../../app/frontend/assets/js/enums/MarketingEventTypeEnum";
import {MarketingEventVariableTypeEnum} from "../../../app/frontend/assets/js/enums/MarketingEventVariableTypeEnum";
import {CurrencyTypeEnum} from "../../../app/frontend/assets/js/enums/CurrencyTypeEnum";

showableCartInstance.initialize().then(() => {
     // запускаем маректинговое событие после инициализации
     biMarketingEventHandler()
});

const biMarketingEventHandler = () => {
    biMarketingEventRunnerRun({
        eventTypeId: MarketingEventTypeEnum.viewCart,
        dynamicData: {
            [MarketingEventVariableTypeEnum.items]: showableCartInstance.getCardsForMarketingEventsFormat(),
            [MarketingEventVariableTypeEnum.currency]: CurrencyTypeEnum.RUB,
            [MarketingEventVariableTypeEnum.value]: showableCartInstance.totalBaseSum,
        }
    });
}

// load problem component
let cartContainer = document.querySelector(`#${
    CartHtmlIdentifierEnum.wrapId
}`) as (HTMLElement | null);
if (cartContainer !== null) {
    const cartRoot = ReactDOM.createRoot(cartContainer);
    cartRoot.render(
            <InitAfterRenderV1>
                 <CartPreOrderWrapV1 {...{
                    showableCart: showableCartInstance
                }} />
            </InitAfterRenderV1>

    );
}